export default "__VITE_ASSET__D4PYdXxK__"